import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

import { inject } from '@angular/core';

import { catchError, switchMap, throwError } from 'rxjs';

import { AuthService } from '../auth/auth-service';
import { SessionService } from '../auth/session-service';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const sessionService = inject(SessionService);

  const isLoginRequest = req.url.includes('/login');
  const isUserRequest = req.url.includes('/users/email');

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isLoginRequest || isUserRequest) {
        return throwError(() => error);
      }

      return authService.refreshTokenIfNeeded().pipe(
        switchMap((success) => {
          if (!success) {
            authService.logout();

            return throwError(() => error);
          }

          const newToken = sessionService.getToken();

          if (!newToken) {
            authService.logout();

            return throwError(() => error);
          }

          const retryRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`,
            },
          });

          return next(retryRequest);
        }),
        catchError((refreshError) => {
          authService.logoutLocal();

          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
